import {connect} from 'react-redux';
import CustomiseComparableItemMap from './CustomiseComparableItemMap';
import {updatePreferences} from 'actionCreators/preferences';
import {findSection, updateSectionValue} from 'ducks/reportSections';
import {getMarkers} from 'lib/MapUtil';

const getComparableKey = (comparableType) => {
  return {
    sales: 'COMPARABLE_SALES_MAP',
    listings: 'COMPARABLE_LISTINGS_MAP',
    rentals: 'COMPARABLE_RENTALS_MAP',
  }[comparableType];
};

const mapStateToProps = (state, {comparableType}) => {
  const {reportSections, reportType: {value: reportTypeValue}, propertyDetail} = state;
  const key = getComparableKey(comparableType);
  const section = findSection(reportSections, reportTypeValue, key);

  return {
    markers: getMarkers(state, comparableType).slice(0, 10),
    targetLatLng: {lat: propertyDetail.latitude, lng: propertyDetail.longitude},
    title: section.sectionData.title,
    center: section.sectionData.center,
    zoom: section.sectionData.zoom,
    reportType: reportTypeValue,
    comparableType,
  };
};

const mapDispatchToProps = (dispatch, {comparableType}) => {
  const key = getComparableKey(comparableType);

  return {
    updateSectionValue: (value, dataKeyPath, reportType) => dispatch(updateSectionValue({
      value,
      reportType,
      key,
      dataKeyPath: `sectionData.${dataKeyPath}`
    })),
    updatePreferences: (preferences, reportType) => {
      dispatch(updatePreferences(preferences, reportType));
    },
    onMapZoomChange: (zoom, reportType) => dispatch(updateSectionValue({
      value: zoom,
      reportType,
      key,
      dataKeyPath: 'sectionData.zoom'
    }, true)),
    onMapCenterChange: (center, reportType) => dispatch(updateSectionValue({
      value: center,
      reportType,
      key,
      dataKeyPath: 'sectionData.center'
    }, true)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => dispatchProps.updateSectionValue(value, dataKeyPath, stateProps.reportType),
    onMapZoomChange: (zoom) => dispatchProps.onMapZoomChange(zoom, stateProps.reportType),
    onMapCenterChange: (center) => dispatchProps.onMapCenterChange(center, stateProps.reportType),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseComparableItemMap);
